<template>
	<div class="he-wrap-content">
		<i class="fas fa-bars he-menu" @click="showHeader = true"></i>
		<div v-show="showHeader" class="he-extended-header">
			<i class="fas fa-times he-close" @click="showHeader = false"></i>
			<p v-if="$route.name != 'Home'" @click="navigateTo('home')">{{ $t('heHome') }}</p>
			<p v-if="$route.name === 'Home'" @click="scrollTo('#Overview')">{{ $t('heOverview') }}</p>
			<p v-if="$route.name === 'Home'" @click="scrollTo('#Smartphone')">{{ $t('heSmartphone') }}</p>
			<p v-if="$route.name === 'Home'" @click="scrollTo('#Connection')">{{ $t('heConnection') }}</p>
			<p v-if="$route.name === 'Home'" @click="scrollTo('#Database')">{{ $t('heDatabase') }}</p>
			<p v-if="$route.name === 'Home'" @click="scrollTo('#Client')">{{ $t('heClient') }}</p>
			<p v-if="$route.name === 'Home'" @click="scrollTo('#About')">{{ $t('heAbout') }}</p>
			<p v-if="$route.name === 'Home'" @click="scrollTo('#Organisation')">{{ $t('heOrganisation') }}</p>
			<p v-if="$route.name != 'Impressum'" @click="navigateTo('impressum')">{{ $t('heLegalNotice') }}</p>
			<p v-if="$route.name != 'AppPrivacy'" @click="navigateTo('datenschutz-app')">{{ $t('heAppPrivacy') }}</p>
			<div class="he-divider"></div>
			<div class="he-wrap-languages">
				<img id="de" class="he-selected-language" :src="require(`@/assets/german.svg`)" :alt="$t('heGerman')" @click="setLanguage('de')" />
				<img id="en" :src="require(`@/assets/english.svg`)" :alt="$t('heEnglish')" @click="setLanguage('en')" />
			</div>
		</div>
	</div>
</template>

<script>
import i18n from '@/translations/i18n';
export default {
	name: 'Header',
	data() {
		return {
			showHeader: false,
		};
	},
	methods: {
		navigateTo(dest) {
			this.showHeader = false;
			this.$router.push({
				path: dest,
			});
		},
		scrollTo(dest) {
			this.showHeader = false;
			document.querySelector(dest).scrollIntoView({ behavior: 'smooth' });
		},
		setLanguage(lang) {
			document.getElementById(lang).classList.add('he-selected-language');
			if (lang == 'de') document.getElementById('en').classList.remove('he-selected-language');
			else document.getElementById('de').classList.remove('he-selected-language');
			i18n.locale = lang;
			window.dispatchEvent(new Event('languageChange'));
			this.showHeader = false;
		},
	},
};
</script>

<style scoped>
.he-wrap-content {
	width: fit-content;
	height: fit-content;
	position: relative;
	padding: 10px;
	background-color: #ffffffcc;
	border-bottom-right-radius: 10px;
}

.he-menu {
	font-size: 25px;
}

.he-menu:hover {
	cursor: pointer;
}

.he-close {
	position: absolute;
	top: 10px;
	right: 10px;
	font-size: 25px;
}

.he-close:hover {
	cursor: pointer;
	color: var(--main-color-warning);
}

.he-extended-header a,
.he-extended-header p {
	display: block;
	margin: 2px 10px;
	font-size: 20px;
	color: var(--main-color-text-dark);
	text-decoration: none;
}

.he-extended-header a:hover,
.he-extended-header p:hover {
	cursor: pointer;
	text-decoration: underline;
}

.he-divider {
	width: 90%;
	margin: 5px 5%;
	border-bottom: 2px solid var(--main-color-border-dark);
}

.he-wrap-languages {
	width: 100px;
	height: 50px;
	margin: auto;
}

.he-wrap-languages img {
	width: 40px;
	height: 24px;
	margin: 10px 5px;
	display: inline-block;
	cursor: pointer;
	opacity: 0.5;
	filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=50)';
	background-color: white;
	vertical-align: top;
}

.he-wrap-languages img:hover {
	border: 2px solid black;
	margin: 8px 3px;
	opacity: 1;
	filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';
}

.he-selected-language {
	border: 2px solid black;
	margin: 8px 3px !important;
	opacity: 1 !important;
	filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';
	pointer-events: none;
}
</style>
